var _rect, _path, _path2, _path3, _path4, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 24H240V130H80V24Z",
    fill: "#4C6170"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236 28H84V126H236V28ZM80 24V130H240V24H80Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194 46H126C123.791 46 122 47.7909 122 50V55C122 57.2091 123.791 59 126 59H194C196.209 59 198 57.2091 198 55V50C198 47.7909 196.209 46 194 46ZM126 42C121.582 42 118 45.5817 118 50V55C118 59.4183 121.582 63 126 63H194C198.418 63 202 59.4183 202 55V50C202 45.5817 198.418 42 194 42H126Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194 73H126C123.791 73 122 74.7909 122 77V82C122 84.2091 123.791 86 126 86H194C196.209 86 198 84.2091 198 82V77C198 74.7909 196.209 73 194 73ZM126 69C121.582 69 118 72.5817 118 77V82C118 86.4183 121.582 90 126 90H194C198.418 90 202 86.4183 202 82V77C202 72.5817 198.418 69 194 69H126Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 98,
    width: 40,
    height: 12,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#B4DDEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormGroup);
export default __webpack_public_path__ + "static/media/form-group.3877d745ef80f9db40ed60c14805d094.svg";
export { ForwardRef as ReactComponent };